// Auto-generated from network-overview.html. Verbatim redesign import. Do NOT edit.
export const STYLES = `

:root{
  --bone:#FAF8F4; --aubergine:#15102A;
  --champ:#A88B4A; --champ-light:#E8D9B8; --lava:#FF7A33;
  --on-surface-muted:#4F4538;
  --box-fill:#FEFCF8; --box-border:#D8D0C2;
  --champ-glow:#F4E5C2; --champ-rim:#5C4824; --champ-night-glow:#FBEFD0;
  --hero-purple-rgb:76,55,120; --hero-bronze-rgb:168,107,61; --hero-striae-rgb:255,255,255;
  --gradient-champ-day:radial-gradient(ellipse at 30% 30%,var(--champ-glow) 0%,var(--champ) 45%,var(--champ-rim) 100%);
  --gradient-champ-night:radial-gradient(ellipse at 30% 30%,var(--champ-night-glow) 0%,var(--champ-light) 50%,var(--champ) 100%);
  --gradient-hero-purple:radial-gradient(ellipse 70% 60% at 0% 0%,rgba(var(--hero-purple-rgb),0.30),transparent 70%);
  --gradient-hero-bronze:radial-gradient(ellipse 80% 60% at 100% 100%,rgba(var(--hero-bronze-rgb),0.22),transparent 70%);
  --gradient-hero-striae:repeating-linear-gradient(135deg,rgba(var(--hero-striae-rgb),0.014) 0,rgba(var(--hero-striae-rgb),0.014) 1px,transparent 1px,transparent 80px);
  --font-display:'Source Serif 4','Iowan Old Style',Georgia,serif;
  --font-mono:'JetBrains Mono','SF Mono',Menlo,monospace;
  --font-body:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
  --track-mono-caps:0.20em; --track-mono:0.04em; --track-display:-0.025em;
  --container-max:1280px; --gutter:clamp(20px,5vw,64px);
  --r:4px; --r-card:8px;
  --ease-out:cubic-bezier(0.22,1,0.36,1);
  --dur-fast:120ms; --dur-base:240ms; --dur-slow:480ms;
}
*{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth}
body{font-family:var(--font-body);background:var(--aubergine);color:var(--bone);-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;overflow-x:hidden}

.eyebrow{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  display:inline-flex;align-items:center;gap:12px;margin-bottom:clamp(20px,3vh,28px);
}
.eyebrow .seal{width:6px;height:6px;transform:rotate(45deg)}
.eyebrow.on-day{color:var(--champ)} .eyebrow.on-day .seal{background:var(--champ)}
.eyebrow.on-night{color:var(--champ-light)} .eyebrow.on-night .seal{background:var(--champ-light)}

h2.head{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4vw,48px);line-height:1.06;letter-spacing:var(--track-display);
  max-width:20ch;
}
h2.head .accent{font-style:italic;color:var(--champ)}
.on-night h2.head .accent,.section-night h2.head .accent{color:var(--champ-light)}
.lede{font-family:var(--font-body);font-size:clamp(16px,1.5vw,19px);line-height:1.6;margin-top:clamp(18px,2.4vh,24px);max-width:62ch}

/* buttons */
.btn{font-family:var(--font-mono);font-size:13px;font-weight:500;letter-spacing:var(--track-mono);text-decoration:none;border-radius:var(--r);padding:15px 26px;display:inline-flex;align-items:center;gap:10px;cursor:pointer;border:none;transition:filter var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out),background-image var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out)}
.btn-primary{background-image:var(--gradient-champ-night);color:var(--aubergine);box-shadow:inset 0 1px 0 rgba(255,255,255,0.45),inset 0 -1px 0 rgba(92,72,36,0.55),0 0 24px rgba(232,217,184,0.20)}
.btn-primary:hover{background-image:radial-gradient(ellipse at 30% 30%,#FFF7E4 0%,#F4E5C2 50%,var(--champ-light) 100%);box-shadow:inset 0 1px 0 rgba(255,255,255,0.7),0 0 36px rgba(244,229,194,0.45);transform:translateY(-1px)}

/* section frames */
.section{padding:clamp(52px,6.5vh,80px) 0}
.wrap{max-width:var(--container-max);margin:0 auto;padding:0 var(--gutter)}
.section-day{background:var(--bone);color:var(--aubergine);position:relative;z-index:1}
.section-night{position:relative;z-index:1;background-color:var(--aubergine);background-image:var(--gradient-hero-striae),var(--gradient-hero-purple),var(--gradient-hero-bronze);color:var(--bone);overflow:hidden}
.section-head{max-width:820px;margin-bottom:clamp(36px,5vh,56px)}
.section-day .lede{color:var(--on-surface-muted)} .section-day h2.head{color:var(--aubergine)}
.section-night .lede{color:rgba(250,248,244,0.78)} .section-night h2.head{color:var(--bone)}

/* ===== PAGE HEADER (hero-lite, aubergine) ===== */
.page-header{position:relative;background-color:var(--aubergine);background-image:var(--gradient-hero-striae),var(--gradient-hero-purple),var(--gradient-hero-bronze);overflow:hidden;padding:clamp(90px,16vh,180px) 0 clamp(64px,10vh,120px)}
/* animated constellation canvas — matches the ix-hero-canvas on solutions
   pages, toned for the dark aubergine hero background. */
.page-header-canvas{position:absolute;inset:0;width:100%;height:100%;z-index:0;opacity:0.85;pointer-events:none}
.page-header-veil{position:absolute;inset:0;z-index:1;pointer-events:none;background:radial-gradient(ellipse 70% 65% at 14% 42%,rgba(21,16,42,0.0),rgba(21,16,42,0.35) 86%),linear-gradient(180deg,transparent 58%,rgba(21,16,42,0.78))}
.page-header::before,.page-header::after{content:"";position:absolute;z-index:0;pointer-events:none;border-radius:50%;filter:blur(40px)}
.page-header::before{width:60vw;height:50vh;top:-10%;left:-12%;background:radial-gradient(ellipse at center,rgba(var(--hero-purple-rgb),0.22),transparent 70%);animation:drift-p 22s var(--ease-out) infinite alternate}
.page-header::after{width:70vw;height:50vh;bottom:-12%;right:-12%;background:radial-gradient(ellipse at center,rgba(var(--hero-bronze-rgb),0.18),transparent 70%);animation:drift-b 26s var(--ease-out) infinite alternate}
@keyframes drift-p{from{transform:translate(0,0) scale(1)}to{transform:translate(4%,3%) scale(1.08)}}
@keyframes drift-b{from{transform:translate(0,0) scale(1)}to{transform:translate(-3%,-4%) scale(1.1)}}
.page-header .wrap{position:relative;z-index:1}
.page-header h1{font-family:var(--font-display);font-weight:400;font-size:clamp(38px,5.6vw,76px);line-height:1.1;letter-spacing:var(--track-display);color:var(--bone);max-width:18ch}
.page-header h1 .accent{font-style:italic;color:var(--champ-light)}
.page-header .lede{color:rgba(250,248,244,0.80);max-width:52ch}
.page-header .cta-row{margin-top:clamp(30px,4vh,44px);display:flex;flex-wrap:wrap;gap:14px}

/* ===== problem cards (pillar-style on day) ===== */
.grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(14px,1.6vw,20px)}
@media(max-width:880px){.grid-3{grid-template-columns:1fr}}
.pcard{background:var(--box-fill);border:1px solid var(--box-border);border-radius:var(--r-card);padding:clamp(22px,2vw,30px);transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out)}
.pcard:hover{border-color:rgba(168,139,74,0.5);transform:translateY(-2px);box-shadow:0 18px 40px -28px rgba(21,16,42,0.4)}
.pcard .ptop{display:flex;align-items:center;gap:10px;margin-bottom:14px}
.pcard .ptop .ico{width:16px;height:16px;color:var(--champ)}
.pcard .ptop .num{font-family:var(--font-mono);font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:var(--champ)}
.pcard h3{font-family:var(--font-display);font-weight:500;font-size:clamp(18px,1.7vw,22px);line-height:1.15;color:var(--aubergine);margin-bottom:10px}
.pcard p{font-family:var(--font-body);font-size:14px;line-height:1.55;color:var(--on-surface-muted)}

/* ===== product cards (lit-card on night) ===== */
.grid-3.products{gap:clamp(16px,1.4vw,22px)}
.prod{position:relative;display:flex;flex-direction:column;height:100%;border:1px solid rgba(232,217,184,0.14);background:rgba(250,248,244,0.025);border-radius:var(--r-card);padding:clamp(22px,2vw,30px);overflow:hidden;transition:border-color var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out)}
.prod:hover{border-color:rgba(232,217,184,0.5);background:rgba(250,248,244,0.045);transform:translateY(-2px)}
.prod .ptop{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px}
.prod .badge{font-family:var(--font-mono);font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--champ-light);border:1px solid rgba(232,217,184,0.4);border-radius:var(--r);padding:5px 10px}
.prod .ico{width:20px;height:20px;color:var(--champ-light)}
.prod h3{font-family:var(--font-display);font-weight:500;font-size:clamp(22px,2vw,27px);line-height:1.1;color:var(--bone)}
.prod .anchor{font-family:var(--font-display);font-style:italic;font-size:15px;color:var(--champ-light);margin-top:8px}
.prod .body{font-family:var(--font-body);font-size:14px;line-height:1.6;color:rgba(250,248,244,0.66);margin-top:16px}
.prod ul{list-style:none;margin-top:18px;display:flex;flex-direction:column;gap:10px}
.prod li{display:flex;gap:10px;font-size:13.5px;line-height:1.5;color:rgba(250,248,244,0.82)}
.prod li .bullet{margin-top:7px;width:4px;height:4px;border-radius:50%;background:var(--champ-light);flex:0 0 auto}
.prod .foot{margin-top:auto;padding-top:22px;border-top:1px solid rgba(232,217,184,0.12)}
.prod .pcta{font-family:var(--font-mono);font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:var(--champ-light);text-decoration:none;display:inline-flex;align-items:center;gap:8px}
.prod .pcta .chev{transition:transform var(--dur-base) var(--ease-out)}
.prod:hover .pcta .chev{transform:translateX(4px)}

/* ===== workflow stage: cards float ON the cream graphic panel ===== */
.wf-stage{
  position:relative;width:100%;margin-top:clamp(24px,3.2vh,40px);
  border-radius:var(--r-card);overflow:hidden;border:1px solid var(--box-border);
  min-height:clamp(380px,52vh,560px);
  background:
    radial-gradient(ellipse 70% 80% at 50% 50%,rgba(255,122,51,0.10),transparent 72%),
    linear-gradient(180deg,#FBF8F2 0%,#F4EEE3 100%);
}
.wf-stage canvas{position:absolute;inset:0;width:100%;height:100%;display:block;z-index:0}
.wf-grid{
  position:relative;z-index:1;
  display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(14px,1.4vw,20px);
  padding:clamp(18px,2.2vw,32px);height:100%;align-items:start;
}
@media(max-width:760px){.wf-grid{grid-template-columns:1fr}.wf-stage{min-height:0}}

/* hover-reveal: detail + CTA open ONLY while a card is hovered (pure hover, no
   card open at rest). the .active class still drives the background graphic. */
.wf-grid.reveal-cards .wcard .cap{margin-bottom:0}
.wf-grid.reveal-cards .wcard .n{margin-top:auto;padding-top:18px}
.wf-grid.reveal-cards .wcard-detail{max-height:0;opacity:0;overflow:hidden;
  transition:max-height 360ms var(--ease-out),opacity 300ms var(--ease-out),margin-top 360ms var(--ease-out);margin-top:0}
.wf-grid.reveal-cards .wcard:hover .wcard-detail{max-height:260px;opacity:1;margin-top:12px}
.wf-grid.reveal-cards .wcard-detail p{font-family:var(--font-body);font-size:12.5px;line-height:1.55;color:var(--on-surface-muted)}
.wf-grid.reveal-cards .wcard-detail .wcta{font-family:var(--font-mono);font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:var(--lava);text-decoration:none;display:inline-flex;gap:7px;margin-top:12px}
.wf-grid.reveal-cards .wcard-detail .wcta .chev{transition:transform var(--dur-base) var(--ease-out)}
.wf-grid.reveal-cards .wcard:hover .wcta .chev{transform:translateX(4px)}
.wcard{
  position:relative;background:rgba(254,252,248,0.62);border:1px solid var(--box-border);border-radius:var(--r-card);
  display:flex;flex-direction:column;overflow:hidden;cursor:pointer;
  backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);
  transition:opacity var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out);
}
.wcard:hover,.wcard.active{background:rgba(254,252,248,0.92)}
.wcard.active{border-color:var(--lava);box-shadow:0 0 0 1px var(--lava),0 18px 40px -24px rgba(21,16,42,0.32)}
.wcard:hover{border-color:var(--lava)}
/* orange top progress hairline on the active card (fills once, like homepage) */
.wcard::before{content:"";position:absolute;left:0;top:0;height:2px;width:100%;background:var(--lava);transform:scaleX(0);transform-origin:left;z-index:2}
.wcard.active::before{animation:wf-progress 1500ms var(--ease-out) forwards}
@keyframes wf-progress{from{transform:scaleX(0)}to{transform:scaleX(1)}}
.wcard-body{padding:clamp(20px,1.6vw,26px);display:flex;flex-direction:column;flex:1}
.wcard .verb{font-family:var(--font-mono);font-size:10.5px;font-weight:500;letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ);margin-bottom:12px;display:inline-flex;align-items:center;gap:8px;transition:color var(--dur-base) var(--ease-out)}
.wcard .verb .tick{width:5px;height:5px;background:var(--champ);transform:rotate(45deg);flex:0 0 auto;transition:background var(--dur-base) var(--ease-out)}
.wcard.active .verb,.wcard:hover .verb{color:var(--lava)}
.wcard.active .verb .tick,.wcard:hover .verb .tick{background:var(--lava)}
.wcard h3{font-family:var(--font-display);font-weight:500;font-size:clamp(19px,1.6vw,24px);line-height:1.15;letter-spacing:-0.01em;color:var(--aubergine);margin-bottom:8px}
.wcard .cap{font-family:var(--font-body);font-size:13.5px;line-height:1.5;color:var(--on-surface-muted);margin-bottom:auto}
.wcard .n{font-family:var(--font-mono);font-size:10px;letter-spacing:0.2em;color:rgba(21,16,42,0.4);margin-top:18px}

/* ===== proof stats ===== */
.proof-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:0}
.proof{padding:8px clamp(14px,2vw,28px) 8px 0;position:relative}
.proof + .proof{padding-left:clamp(20px,2.4vw,32px);border-left:1px solid var(--box-border)}
.proof .num{font-family:var(--font-display);font-weight:400;font-size:clamp(34px,4.2vw,60px);line-height:1;letter-spacing:-0.02em;color:var(--aubergine);font-variant-numeric:tabular-nums;display:flex;align-items:baseline;gap:2px}
.proof .num .suffix{font-size:0.5em;color:var(--champ);font-style:italic;margin-left:2px}
.proof .num.status{font-size:clamp(20px,2.4vw,34px);font-style:italic;color:var(--champ)}
.proof .lbl{margin-top:14px;font-family:var(--font-body);font-size:13.5px;line-height:1.45;color:var(--on-surface-muted);max-width:22ch}
@media(max-width:900px){
  .proof-grid{grid-template-columns:repeat(2,1fr)}
  .proof{padding:clamp(20px,4vw,28px) clamp(16px,4vw,24px)}
  .proof + .proof{border-left:none}
  .proof:nth-child(even){border-left:1px solid var(--box-border)}
  .proof:nth-child(n+3){border-top:1px solid var(--box-border)}
}

/* ===== closing 'doors' CTA row ===== */
/* Flex + center so any number of doors (2 or 3) sits in the middle of the
   section. Mirrors the landing hero .cta-row exactly on mobile. */
.doors{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:14px;max-width:760px;margin:clamp(36px,5vh,48px) auto 0}
.door{display:inline-flex;align-items:center;justify-content:center;gap:10px;text-decoration:none;border-radius:var(--r);padding:15px 26px;background-image:var(--gradient-champ-night);color:var(--aubergine);font-family:var(--font-mono);font-size:13px;letter-spacing:var(--track-mono);font-weight:500;border:none;box-shadow:inset 0 1px 0 rgba(255,255,255,0.45),inset 0 -1px 0 rgba(92,72,36,0.55),0 0 24px rgba(232,217,184,0.20);transition:filter var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out),background-image var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out)}
.door:hover{filter:brightness(1.08);background-image:radial-gradient(ellipse at 30% 30%,#FFF7E4 0%,#F4E5C2 50%,var(--champ-light) 100%);box-shadow:inset 0 1px 0 rgba(255,255,255,0.7),inset 0 -1px 0 rgba(92,72,36,0.5),0 0 36px rgba(244,229,194,0.45);transform:translateY(-1px)}
.door:active{transform:translateY(0.5px)}
@media(max-width:640px){
  .doors{gap:10px}
  .door{flex:1 1 auto;min-width:48%}
}
@media(max-width:420px){
  .door{min-width:100%}
}
.center{text-align:center}
.center h2.head{margin-left:auto;margin-right:auto}
.center .lede{margin-left:auto;margin-right:auto}

/* reveal (gentle, visible by default) */
@keyframes rise{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.reveal{animation:rise var(--dur-slow) var(--ease-out) both}
@media(prefers-reduced-motion:reduce){*{animation:none!important}}
/* ===== THE PROBLEM — fragmented vs unified side-by-side ===== */
.pv-compare{max-width:1120px;margin:clamp(30px,4.5vh,52px) auto 0;display:grid;grid-template-columns:1fr auto 1fr;gap:clamp(16px,2.4vw,30px);align-items:stretch}
.cmp{position:relative;display:flex;flex-direction:column;border:1px solid var(--box-border);border-radius:14px;padding:clamp(24px,2.8vw,34px);background:var(--box-fill);overflow:hidden;
  box-shadow:0 1px 2px rgba(21,16,42,0.04),0 8px 30px rgba(21,16,42,0.05);transition:transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out)}
.cmp:hover{transform:translateY(-2px)}
.cmp::before{content:"";position:absolute;inset:0 0 auto 0;height:2px;opacity:0.9}
.cmp.is-today{background:var(--box-fill)}
.cmp.is-today::before{background:radial-gradient(ellipse at 50% 50%,rgba(168,139,74,0.35),transparent 75%)}
.cmp.is-today:hover{box-shadow:0 1px 2px rgba(21,16,42,0.04),0 12px 36px rgba(21,16,42,0.07)}
.cmp.is-trex{background:radial-gradient(ellipse 90% 70% at 50% 0%,rgba(168,139,74,0.10),transparent 60%),var(--box-fill);border-color:rgba(168,139,74,0.4)}
.cmp.is-trex::before{background:radial-gradient(ellipse at 50% 50%,var(--champ),transparent 75%)}
.cmp.is-trex:hover{box-shadow:0 1px 2px rgba(168,139,74,0.08),0 14px 40px rgba(168,139,74,0.16)}
.cmp .cmp-label{font-family:var(--font-mono);font-size:10.5px;letter-spacing:0.16em;text-transform:uppercase;margin-bottom:11px}
.cmp.is-today .cmp-label{color:var(--on-surface-muted)}
.cmp.is-trex .cmp-label{color:var(--champ)}
.cmp h3{font-family:var(--font-display);font-weight:500;font-size:clamp(18px,1.9vw,23px);line-height:1.12;color:var(--aubergine);margin-bottom:20px}
.cmp .cmp-diagram{position:relative;display:flex;align-items:center;justify-content:center;height:clamp(180px,22vw,240px);padding:8px 0}
.cmp .cmp-diagram svg{width:100%;height:100%;max-width:460px;display:block;overflow:visible}
.cmp .cmp-foot{margin-top:0;padding-top:20px;font-family:var(--font-body);font-size:12.5px;line-height:1.55;color:var(--on-surface-muted)}
.cmp.is-trex .cmp-foot{color:var(--on-surface-muted)}
.pv-compare .cmp-vs{align-self:center;justify-self:center;width:38px;height:38px;border-radius:50%;border:1px solid var(--box-border);background:var(--bone);display:flex;align-items:center;justify-content:center;font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;text-transform:uppercase;color:var(--on-surface-muted);box-shadow:0 4px 14px rgba(21,16,42,0.08);position:relative;z-index:2}
.pv-compare .cmp{opacity:0;transform:translateY(16px);transition:opacity 560ms var(--ease-out),transform 560ms var(--ease-out)}
.pv-compare.built .cmp.is-today{opacity:1;transform:none}
.pv-compare.built .cmp.is-trex{opacity:1;transform:none;transition-delay:200ms}
@media(max-width:760px){
  .pv-compare{grid-template-columns:1fr;gap:14px}
  .pv-compare .cmp-vs{transform:none}
}




/* ===== T-REX global chrome (scoped, self-contained) ===== */
.tgn,.tgf{--tgc-aub:#15102A;--tgc-aub2:#1A1531;--tgc-aub3:#221A42;--tgc-bone:#FAF8F4;
  --tgc-champ:#A88B4A;--tgc-champL:#E8D9B8;--tgc-lava:#FF7A33;
  font-family:'Inter',system-ui,-apple-system,Segoe UI,Roboto,sans-serif;box-sizing:border-box;}
.tgn *,.tgf *{box-sizing:border-box;}
.tgn{position:sticky;top:0;z-index:1000;background:rgba(21,16,42,0.90);
  -webkit-backdrop-filter:saturate(140%) blur(14px);backdrop-filter:saturate(140%) blur(14px);
  border-bottom:1px solid rgba(232,217,184,0.12);}
.tgn-bar{max-width:1240px;margin:0 auto;height:60px;padding:0 clamp(18px,4vw,40px);
  display:flex;align-items:center;justify-content:space-between;gap:24px;}
.tgn-brand{display:inline-flex;align-items:center;line-height:0;flex:0 0 auto;}
.tgn-wordmark{height:24px;width:auto;display:block;}
.tgn-links{display:flex;align-items:center;gap:clamp(6px,1.4vw,18px);}
.tgn-item{position:relative;display:flex;align-items:center;height:60px;}
.tgn-link{display:inline-flex;align-items:center;gap:5px;color:rgba(250,248,244,0.74);
  text-decoration:none;font-size:14px;font-weight:500;letter-spacing:.01em;padding:6px 4px;
  transition:color .18s ease;}
.tgn-link:hover,.tgn-item:hover .tgn-link{color:var(--tgc-bone);}
.tgn-link.tgn-active{color:var(--tgc-bone);}
.tgn-caret{font-size:9px;opacity:.7;transition:transform .2s ease;}
.tgn-item:hover .tgn-caret{transform:translateY(1px);}
.tgn-ext{font-size:11px;opacity:.7;}
.tgn-menu{position:absolute;top:58px;left:-14px;min-width:280px;padding:8px;
  background:var(--tgc-aub2);border:1px solid rgba(232,217,184,0.14);border-radius:12px;
  box-shadow:0 24px 60px -20px rgba(0,0,0,0.7);opacity:0;visibility:hidden;transform:translateY(6px);
  transition:opacity .18s ease,transform .18s ease,visibility .18s;}
.tgn-has-menu:hover .tgn-menu{opacity:1;visibility:visible;transform:translateY(0);}
.tgn-menu a{display:flex;flex-direction:column;gap:2px;padding:10px 12px;border-radius:8px;
  text-decoration:none;transition:background .15s ease;}
.tgn-menu a span{color:var(--tgc-bone);font-size:14px;font-weight:600;}
.tgn-menu a small{color:rgba(250,248,244,0.55);font-size:12px;font-weight:400;}
.tgn-menu a:hover{background:var(--tgc-aub3);}
.tgn-actions{display:flex;align-items:center;gap:12px;flex:0 0 auto;}
.tgn-cta{display:inline-flex;align-items:center;text-decoration:none;font-size:13.5px;font-weight:600;
  color:var(--tgc-aub);padding:9px 18px;border-radius:9px;white-space:nowrap;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);
  box-shadow:0 1px 0 rgba(255,255,255,0.4) inset,0 6px 18px -8px rgba(232,217,184,0.5);
  transition:transform .16s ease,box-shadow .16s ease;}
.tgn-cta:hover{transform:translateY(-1px);box-shadow:0 10px 24px -10px rgba(232,217,184,0.7);}
.tgn-burger{display:none;flex-direction:column;justify-content:center;gap:4px;width:40px;height:38px;
  background:transparent;border:1px solid rgba(232,217,184,0.22);border-radius:9px;cursor:pointer;padding:0 9px;}
.tgn-burger span{display:block;height:2px;width:100%;background:var(--tgc-bone);border-radius:2px;transition:transform .2s ease,opacity .2s ease;}
.tgn.tgn-open .tgn-burger span:nth-child(1){transform:translateY(6px) rotate(45deg);}
.tgn.tgn-open .tgn-burger span:nth-child(2){opacity:0;}
.tgn.tgn-open .tgn-burger span:nth-child(3){transform:translateY(-6px) rotate(-45deg);}
.tgn-panel{display:none;flex-direction:column;padding:10px clamp(18px,4vw,40px) 22px;
  background:var(--tgc-aub);border-top:1px solid rgba(232,217,184,0.1);gap:2px;}
.tgn.tgn-open .tgn-panel{display:flex;}
.tgn-acc{border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-acc summary{list-style:none;cursor:pointer;color:var(--tgc-bone);font-size:15px;font-weight:600;
  padding:14px 2px;display:flex;justify-content:space-between;align-items:center;}
.tgn-acc summary::-webkit-details-marker{display:none;}
.tgn-acc summary::after{content:"+";color:var(--tgc-champL);font-size:18px;}
.tgn-acc[open] summary::after{content:"\\2212";}
.tgn-acc a{display:block;color:rgba(250,248,244,0.7);text-decoration:none;font-size:14px;padding:9px 2px 9px 14px;}
.tgn-acc a:hover{color:var(--tgc-bone);}
.tgn-plink{display:block;color:var(--tgc-bone);text-decoration:none;font-size:15px;font-weight:600;
  padding:14px 2px;border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-pcta{display:block;text-align:center;margin-top:16px;text-decoration:none;font-size:14.5px;font-weight:600;
  color:var(--tgc-aub);padding:13px 18px;border-radius:10px;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);}
@media(max-width:900px){
  .tgn-links{display:none;}
  .tgn-burger{display:flex;}
  .tgn-cta{display:none;}
}
.tgf{background:var(--tgc-aub);color:rgba(250,248,244,0.72);border-top:1px solid rgba(232,217,184,0.1);}
.tgf-inner{max-width:1240px;margin:0 auto;padding:64px clamp(18px,4vw,40px) 40px;}
.tgf-wordmark{height:26px;width:auto;display:block;margin-bottom:18px;}
.tgf-tag{font-size:15px;line-height:1.5;color:rgba(250,248,244,0.7);max-width:320px;margin:0 0 20px;}
.tgf-cta{display:inline-block;color:var(--tgc-champL);text-decoration:none;font-size:14px;font-weight:600;}
.tgf-cta:hover{color:var(--tgc-bone);}
.tgf-cols{display:grid;grid-template-columns:repeat(4,1fr);gap:28px;}
.tgf-col h4{color:var(--tgc-bone);font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;margin:0 0 14px;}
.tgf-col a{display:block;color:rgba(250,248,244,0.6);text-decoration:none;font-size:14px;padding:6px 0;transition:color .15s ease;}
.tgf-col a:hover{color:var(--tgc-bone);}
.tgf-top{display:grid;grid-template-columns:1.3fr 2fr;gap:48px;}
.tgf-base{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;flex-wrap:wrap;
  margin-top:48px;padding-top:24px;border-top:1px solid rgba(232,217,184,0.1);}
.tgf-base p{margin:0;font-size:12.5px;color:rgba(250,248,244,0.5);}
.tgf-legal{max-width:560px;text-align:right;}
@media(max-width:820px){
  .tgf-top{grid-template-columns:1fr;gap:36px;}
  .tgf-cols{grid-template-columns:repeat(2,1fr);}
  .tgf-base{flex-direction:column;}
  .tgf-legal{text-align:left;}
}



/* uniform section gap on every page (fixed px, no vh/rem drift) */
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:80px!important;padding-bottom:80px!important}
@media(max-width:768px){
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:52px!important;padding-bottom:52px!important}}

`;
